var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 512,
    height: 341.326,
    y: 85.337
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff9811"
    },
    width: 512,
    height: 113.775,
    y: 85.337
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6da544"
    },
    width: 512,
    height: 113.775,
    y: 312.888
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0052b4"
    },
    cx: 256,
    cy: 256,
    r: 43.896
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#f0f0f0"
    },
    cx: 256,
    cy: 256,
    r: 27.434
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052b4"
    },
    points: "256 222.146 264.464 241.341 285.319 239.073 272.927 256 285.319 272.927 264.464 270.659 256 289.854 247.536 270.659 226.681 272.927 239.073 256 226.681 239.073 247.536 241.341"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHin);
export default __webpack_public_path__ + "static/media/hin.8a58faf94ae25713d3954ec8e60a0225.svg";
export { ForwardRef as ReactComponent };